export function formatUZS(n: number): string {
  return new Intl.NumberFormat('ru-RU').format(n);
}

export function formatDateTime(iso: string, lang: 'ru' | 'uz' = 'ru'): string {
  const d = new Date(iso);
  const locale = lang === 'uz' ? 'uz-UZ' : 'ru-RU';
  return d.toLocaleString(locale, {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDate(iso: string, lang: 'ru' | 'uz' = 'ru'): string {
  const d = new Date(iso);
  return d.toLocaleDateString(lang === 'uz' ? 'uz-UZ' : 'ru-RU', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}
